const E = {
  AdditionalSupplies:
    "Note: Your supply order will be prepared based on the tests and samples selected and will include standard supplies such as a cooler and bubble wrap (as applicable).",
  Samples: 'Samples',
  AddSamples: 'Add Sample',
  AddQcSamples: 'Add QC Sample',
  QcSamples: 'QC Samples',
  PackagelessSamples:
    'Samples without packages/tests selected will be removed from the order.',
  TotalSamples: 'Total Samples',
  AdditionalSamples: 'Additional Samples',
  QcType: 'QC Type',
  Matrix: 'Matrix',
  QcSampleId: 'QC Sample ID',
  TotalQcSamples: 'Total QC Samples',
  SampleId: 'Sample ID',
  BackToQcSamples: 'Back to Qc Samples',
  error1: 'QC Samples should not have same QCSample ID',
  SamplesLimit: 'Please note that orders are restricted to 200 samples.',

  'FIELD BLANK': 'FIELD BLANK',
  'TRIP BLANK': 'TRIP BLANK',
  'TRIP SPIKE': 'TRIP SPIKE',
};

const F = {
  AddSamples: 'Ajouter un échantillon',
  BackToQcSamples: 'Revenir aux échantillons de CQ',
  AddQcSamples: 'Ajouter un échantillon de CQ',
  Samples: 'Échantillons',
  QcSamples: 'Échantillons de CQ',
  PackagelessSamples:
    'Les échantillons pour lesquels aucune analyse n’est cochée ne seront pas conservés dans la commande. Merci de revoir votre choix et de sélectionner au moins une analyse.',
  TotalSamples: 'Nombre total d’échantillons',
  AdditionalSamples: 'Échantillons supplémentaires',
  QcType: 'Type de QC',
  Matrix: 'Matrice',
  QcSampleId: 'ID de l’échantillon de CQ',
  TotalQcSamples: 'Nombre total d’échantillons de CQ',
  SampleId: 'ID de l’échantillon',
  error1: 'Les échantillons de CQ ne peuvent pas avoir le même ID',
  SamplesLimit:
    'Veuillez noter que les commandes de matériel sont limitées à 200 échantillons.',
  AdditionalSupplies:
    "Votre commande sera préparée basée sur votre choix d’analyses et du nombre d’échantillons sélectionnés, elle inclura par défaut, si aucun avis contraire de votre part à l’étape 5, les fournitures habituelles comme une glacière, un bloc réfrigérant et du papier bulles (si applicable).",
  'FIELD BLANK': 'BLANC DE TERRAIN',
  'TRIP BLANK': 'BLANC DE TRANSPORT',
  'TRIP SPIKE': 'BLANC FORTIFIÉ',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/formsOrderSamples.js